import React from 'react';

const Edit = (props: { className: any, onClick?: any }) => {
  const { className, onClick } = props;

  const handleOnClick = (e: any) => {

    if (onClick) onClick(true);
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} onClick={handleOnClick}>
        <g id="edit">
        <path id="Vector" d="M7.94745 2.04032L1.78995 8.32234C1.55745 8.5609 1.33245 9.03079 1.28745 9.35609L1.00995 11.6983C0.912452 12.5441 1.54245 13.1224 2.41245 12.9778L4.82745 12.5802C5.16495 12.5224 5.63745 12.2838 5.86995 12.0381L12.0275 5.75604C13.0925 4.67168 13.5725 3.43552 11.915 1.92465C10.265 0.428245 9.01245 0.955964 7.94745 2.04032Z"  stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path id="Vector_2" d="M6.91992 3.08856C7.24242 5.08377 8.92242 6.6091 11.0074 6.81151"  stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
    </svg>
  );
};
export default Edit;



